// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DmjQcDApF1HpbieFh0zU{font-size:13px;line-height:1.2;text-align:center}.rd74SimgA8roV050N225,.Vjr8bgQJ0zfGJ8wuEwNn{font-weight:bold;color:initial}`, "",{"version":3,"sources":["webpack://./src/components/cards/defaults/ItemHorizontalCard/components/CardInfo/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,eAAA,CACA,iBAAA,CACF,4CAEE,gBAAA,CACA,aAAA","sourcesContent":[".combined\n  font-size: 13px\n  line-height: 1.2\n  text-align: center\n.label,\n.value\n  font-weight: bold\n  color: initial\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"combined": `DmjQcDApF1HpbieFh0zU`,
	"label": `rd74SimgA8roV050N225`,
	"value": `Vjr8bgQJ0zfGJ8wuEwNn`
};
export default ___CSS_LOADER_EXPORT___;
